<template>
  <div v-if="cellProps" class="flex-row gap-xxs align-items-center">
    <a-tooltip
        :title="cellProps.full_name"
    >
      <a class="paragraph m-0" :href="`/customer/${cellProps.id}/`">
        <a-avatar :src="avatarUri" size="small">
        </a-avatar>
        <span class="btn-link" style="text-decoration: underline;">
        {{ name }}
        </span>
      </a>
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: 'CustomerAvatarCell.vue',
  props: {
    cellProps: {
      full_name: String,
      first_name: String,
      last_name: String,
      id: String,
    },
  },
  computed: {
    avatarUri () {
      return '/customer/' + this.cellProps.id + '/avatar'
    },
    name () {
      return this.cellProps.first_name || this.cellProps.last_name || this.cellProps.full_name || 'Geen naam'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.avatars {
  margin-left: 10px;

  .custom-avatar-wrapper {
    margin-left: -10px;
  }

  .ant-avatar {
    border: 1px solid white;
  }

  .overflow {
    .ant-avatar {
      background-color: $brand-primary;
      color: white;
      font-weight: 500;
      font-size: $font-size-small;
    }
  }
}
</style>
